import { EventsScreen } from '@/components/domain/events/EventsScreen';

export default function EventsNetwork() {
  return <EventsScreen initialListType="network" />;
}
